/**
 * Every piece of UI that requires javascript should have its own
 * javascript file. Use this file as a template for structuring
 * all JS source files.
 *
 * Viewport Animations
 *
 * class to use with Waypoint to show animations when viewport comes into scroll
 *
 * Dependencies: jQuery, Waypoints
 *
 * @return void
 *
 *
 */

const $ = require( 'jQuery' );

var Animatible = function(el){
    this.$el                = $(el);

    this.$animationSettings  = this.$el.attr( 'data-itbl-animation' ) ? JSON.parse( this.$el.attr( 'data-itbl-animation' )  ) : {} ;
    this.$windowWidth       = $(window).width() / 2;
    this.$elLeftPosition    = this.$el.offset().left;
    this.$elSide            = ( this.$windowWidth < this.$elLeftPosition  ) ? 'fadeInRight' : 'fadeInLeft';
    this.offsetTrigger      = '50%';
    var that = this;
    //setup global defaults for this instance, important as a fallback
    this.globalDefaults     = {
        animationSpeed  : 'animated',
        animation       : 'itbl-e-slide-up',
        scrollTarget    : 'self', //target: ['self', 'children', 'childrenStaggered', 'headers']
        elementTarget   : this.$el,
        delay           : 500,
        event           : 'click',
        action          : null,
        secondAnimation : null
    };



    //merge settings with to create an options object
    this.options = $.extend( {}, this.globalDefaults, this.$animationSettings );

    this.init();
};

Animatible.prototype.init = function(){

    //on load, fire the function to setup animationa
    if (typeof this[ this.options.action ] === "function" && typeof this[ this.options.action ] !== "undefined" ) {

        // safe to use the function
        this[ this.options.action ]();
    }

};

Animatible.prototype.animateToggle = function(){

    //add event handlers
    $(document).one(  this.options.event, this.options.elementTarget , function( event ){

        event.preventDefault();

        $( event.target ).one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function(event ) {

            $(event.target).toggleClass( this.option.animation , this.option.secondAnimation );
        }.bind(this))

    }.bind( this ) );


};

Animatible.prototype.animateOnScroll = function(){


    let waypoint;
    const that = this;


    if( this.options.scrollTarget === 'childrenStaggered') {


        this.$children = this.$el.children();


        waypoint = new Waypoint({
            element: that.$el,
            handler: function (direction) {

                that.$children.each(function (index, el) {

                    setTimeout(function () {
                        $(el)
                            .animateCss(that.options.animationSpeed, that.options.animation);
                    }, index * that.options.delay);

                });

                this.destroy();

            },
            offset: that.offsetTrigger
        });


    }else if( this.options.scrollTarget ===  'children' ){
        //show all children on scroll
        this.children = this.$el.children();

        waypoint = this.children.waypoint({
            handler: function(direction) {

                $(this.element).animateCss( that.options.animationSpeed, that.options.animation );

                this.destroy();

            },
            offset: that.offsetTrigger
        });



    }else if( this.options.scrollTarget ===  'headers' ) {

        //if we are only animating headers
        this.headers = this.$el.find( 'h1, h2' );

        waypoint = this.headers.waypoint({
            handler: function(direction) {

                $(this.element).animateCss( that.options.animationSpeed, that.options.animation );

                this.destroy();

            },
            offset: that.offsetTrigger
        });



    }else if( this.options.animation === 'fromSide'  ){


            //check to see if we are closer to the right side or left

            //on right side
            waypoint = new Waypoint({
                element: that.$el,
                handler: function(direction) {

                    that.$el.animateCss( that.options.animationSpeed, that.$elSide );

                    this.destroy();


                },
                offset: that.offsetTrigger
            });


    }else{
        //all the other animations
        waypoint = new Waypoint({
            element: that.$el,
            handler: function(direction) {

                that.$el.animateCss( that.options.animationSpeed, that.options.animation );

                this.destroy();
            },
            offset: this.offsetTrigger
        });

    }


};

Animatible.prototype.transitionToggle = function(){

    //add event handlers
    $(document).on(  this.event, this.elementTarget , function( event ){

        event.preventDefault();

        $( event.target ).toggleClass( 'transform-active' );
    }.bind( this ) );
};


Animatible.prototype.event__handleResize = function(event){

    if( Foundation.MediaQuery.atLeast('medium') ){

        this.setup__triggerAnimation();

    }

};


//helpers
$.fn.extend({
    animateCss: function(animationSpeed, animationName, callback) {
        var animationEnd = (function(el) {
            var animations = {
                animation: 'animationend',
                OAnimation: 'oAnimationEnd',
                MozAnimation: 'mozAnimationEnd',
                WebkitAnimation: 'webkitAnimationEnd',
            };

            for (var t in animations) {
                if (el.style[t] !== undefined) {
                    return animations[t];
                }
            }
        })(document.createElement('div'));

        this.addClass( `${animationSpeed} ${animationName}` ).one( animationEnd, function() {
            $(this)
                .css('opacity', '1')
                .removeClass( `${animationName}` );

            if (typeof callback === 'function') callback();
        });

        return this;
    },
});

$.fn.extend({
    itblAnimate: function(animationSpeed, animationName, callback) {
        var animationEnd = (function(el) {
            var animations = {
                animation: 'animationend',
                OAnimation: 'oAnimationEnd',
                MozAnimation: 'mozAnimationEnd',
                WebkitAnimation: 'webkitAnimationEnd',
            };

            for (var t in animations) {
                if (el.style[t] !== undefined) {
                    return animations[t];
                }
            }
        })(document.createElement('div'));

        return this.addClass( `${animationSpeed} ${animationName}` ).one( animationEnd, function() {
            $(this)
                .removeClass( `${animationName}` );

            if (typeof callback === 'function') callback();
        });


    },
});


$(document).ready(function(){
    $('.js-animatible').each(function(){
        new Animatible(this);
    });

});
